import React, { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'
import { getUnpaidSiblings } from 'services/fund'

export default function useGetUnpaidSiblings() {
    const [selectData, setSelectData] = useState<ISelectOption[]>([])
    const { moneyPool, loanId, installmentId } = useParams()
    const { data } = useQuery(
        ['get-unpaid-siblings', moneyPool, loanId, installmentId],
        getUnpaidSiblings
    )
    useEffect(() => {
        if (data) {
            const newData: ISelectOption[] = []
            data.map((item) =>
                newData.push({ value: String(item), label: `قسط ${item}` })
            )
            setSelectData(newData)
        }
    }, [data])
    return { selectData }
}
